export default __webpack_public_path__ + "static/media/ddsu5168_2p_blue_rs485_master_4p.47f1ec0a.jpg";